import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAetherContext } from '#pplx/frontend/aether/components/AetherProvider/useAetherContext.js';
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { SkillsMenuContent } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/SkillsMenuContent.js';
import { usePluginsNavigationHrefs } from '#pplx/frontend/apps/ask/connectors/hooks/usePluginsNavigationHrefs.js';
import { skillsSubmenuOpenedEvent } from '#pplx/frontend/apps/ask/events/ask-input-plus-menu/analytics.js';
import { getSkillDisplayDescription, getSkillDisplayName, } from '#pplx/frontend/apps/ask/skill-cards/skillDisplay.js';
import { useSelectableSkills } from '#pplx/frontend/apps/ask/skills/hooks/useSelectableSkills.js';
import { useDebouncedValue } from '#pplx/frontend/common/hooks/useDebouncedValue.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { memo, useCallback, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
const SKILLS_LIMIT = 100;
const SKILLS_MENU_MIN_WIDTH_PX = 225;
const SKILLS_MENU_MAX_HEIGHT_PX = 310;
export const AskInputPlusMenuSkills = memo(function AskInputPlusMenuSkills({ submenuMaxWidth, onSkillSelect, collectionUuid, showSkillDescriptionPopover, }) {
    const { manageSkills } = usePluginsNavigationHrefs();
    const { isMobileStyle } = useAetherContext();
    const { track } = useInstrumentation();
    const [isOpen, setIsOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const debouncedSearchQuery = useDebouncedValue(searchQuery, 150);
    const { skills, isLoading } = useSelectableSkills({
        app: 'computer',
        limit: SKILLS_LIMIT,
        enabled: isOpen,
        collectionUuid,
    });
    const filteredSkills = useMemo(() => {
        const query = debouncedSearchQuery.trim().toLowerCase();
        if (!query)
            return skills;
        return skills.filter((skill) => skill.name.toLowerCase().includes(query) ||
            skill.description.toLowerCase().includes(query) ||
            getSkillDisplayName(skill).toLowerCase().includes(query) ||
            getSkillDisplayDescription(skill).toLowerCase().includes(query));
    }, [skills, debouncedSearchQuery]);
    const onToggle = useCallback((open) => {
        setIsOpen(open);
        if (open) {
            track(skillsSubmenuOpenedEvent);
            return;
        }
        setSearchQuery('');
    }, [track]);
    return (_jsxs(DropdownMenu.Submenu, { isOpen: isOpen, onToggle: onToggle, maxHeightPx: SKILLS_MENU_MAX_HEIGHT_PX, triggerElement: _jsx(DropdownMenu.SubmenuItem, { leadingAccessory: $icon('blocks'), children: _jsx(FormattedMessage, { defaultMessage: "Use skills", description: "Submenu item label for selecting skills to use", id: "29f9228104" }) }), minWidthPx: SKILLS_MENU_MIN_WIDTH_PX, maxWidthPx: submenuMaxWidth, children: [_jsx(SkillsMenuContent, { searchQuery: searchQuery, setSearchQuery: setSearchQuery, filteredSkills: filteredSkills, isLoading: isLoading, onSkillSelect: onSkillSelect, showSkillDescriptionPopover: showSkillDescriptionPopover }), _jsxs(DropdownMenu.Footer, { children: [!isMobileStyle && _jsx(DropdownMenu.Separator, {}), _jsx(DropdownMenu.LinkItem, { leadingAccessory: _jsx(Icon, { icon: $icon('settings'), size: "small" }), href: manageSkills, target: "_blank", rel: "noopener", children: _jsx(FormattedMessage, { defaultMessage: "Manage skills", description: "Footer link in the skills menu that navigates to the skills management page", id: "bd55b5d9f0" }) })] })] }));
});
//# sourceMappingURL=AskInputPlusMenuSkills.js.map